import React from "react";
import { gerarLinkWhatsApp } from "../../../utils/WhatsappLink";

const HeaderBlog = ({ titulo, subtitulo, data, tempoLeitura }) => {
    return (
        <div style={{ height: "fit-content", backgroundColor: "#050505", color: "#fff", position: "relative", fontFamily: "'Inter', sans-serif", marginBottom: "30px", }} >
            <div style={{ position: "absolute", inset: 0, backgroundImage: ` repeating-linear-gradient( -45deg, transparent, transparent 40px, rgba(255, 60, 0, 0.08) 41px ) `, zIndex: 0, }} />
            <header style={{ position: "relative", zIndex: 2, display: "flex", justifyContent: "space-between", alignItems: "center", padding: "30px 40px", flexWrap: "wrap", gap: "20px", }} >
                <h1 style={{ fontSize: "clamp(1.5rem, 4vw, 2rem)", fontWeight: "800", margin: 0, lineHeight: 1.1, cursor: "pointer", }} onClick={() => window.location.href = "/Blog"} >
                    <span style={{ color: "#fff" }}>Contblack</span>
                    <span style={{ color: "#1EFF86" }}> blog</span>
                </h1>
                <nav style={{ display: "flex", gap: "24px", alignItems: "center", flexWrap: "wrap", justifyContent: "center", }} >
                    <a href="/" style={{ color: "#fff", textDecoration: "none", fontSize: "15px", fontWeight: 500, transition: "0.3s", whiteSpace: "nowrap", }} >
                        Site
                    </a>
                    <a href={gerarLinkWhatsApp("Olá, vim pelo blog e gostaria de atendimento.")} style={{ color: "#fff", textDecoration: "none", fontSize: "15px", fontWeight: 500, transition: "0.3s", whiteSpace: "nowrap", }} >
                        Falar com especialista
                    </a>
                </nav>
            </header>
            <section style={{ position: "relative", zIndex: 2, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", padding: "60px 20px", maxWidth: "1100px", margin: "0 auto", }} >
                <div style={{ background: "#D43C2E", color: "#fff", padding: "10px 18px", borderRadius: "4px", fontSize: "13px", fontWeight: "700", letterSpacing: "1px", marginBottom: "35px", textTransform: "uppercase", }} >
                    ⚠ ALERTA FISCAL
                </div>
                <h2 style={{ fontSize: "clamp(2rem, 3vw, 3rem)", lineHeight: 1.1, fontWeight: "700", maxWidth: "1000px", marginBottom: "35px", fontFamily: "'Georgia', serif", }} >
                    {titulo}
                </h2>
                <p
                    style={{
                        fontSize: "1rem",
                        lineHeight: 1.7,
                        maxWidth: "760px",
                        color: "#C5C5C5",
                        marginBottom: "45px",
                    }}
                >
                    {subtitulo}
                </p>

                {/* Footer info */}
                <div
                    style={{
                        display: "flex",
                        gap: "18px",
                        alignItems: "center",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        color: "#9A9A9A",
                        fontSize: "15px",
                    }}
                >
                    <span>ContBlack</span>
                    <span>•</span>
                    <span>{data}</span>
                    <span>•</span>
                    <span>{tempoLeitura} min de leitura</span>
                </div>
            </section>
        </div>
    );
};

export default HeaderBlog;